export const environment = {
  production: true,
  baseUrl: 'https://hushcity2.edge-works.net/api2/',
  locationDefault: { lat: 53.553741, lng: 10.024552 }
};
